import { defineSseEvent } from '@terra/shared-sse-contracts';
import { z } from 'zod';
import {
  AssetMergeAssetTypeSchema,
  AssetMergeHistoryStatusSchema,
  AssetMergeModeSchema,
  AssetMergeSurvivorKindSchema,
} from './asset-merge.schema';

export const ASSET_MERGE_UPDATED_SSE_TYPE = 'ASSET_MERGE_UPDATED' as const;

export const AssetMergeCommandSseStatusSchema = z.enum([
  'ACCEPTED',
  'NEEDS_FORCE_FINISH',
]);

export const AssetMergeUpdatedSseStatusSchema =
  AssetMergeHistoryStatusSchema.or(AssetMergeCommandSseStatusSchema);

export const AssetMergeUpdatedSsePayloadSchema = z.object({
  applicationId: z.string(),
  assetType: AssetMergeAssetTypeSchema.optional(),
  survivorId: z.string().optional(),
  loserIds: z.array(z.string()).optional(),
  survivorKind: AssetMergeSurvivorKindSchema.optional(),
  historyId: z.string().optional(),
  status: AssetMergeUpdatedSseStatusSchema,
  mode: AssetMergeModeSchema.optional(),
  message: z.string().optional(),
});

export const ASSET_MERGE_UPDATED_SSE_EVENT = defineSseEvent({
  type: ASSET_MERGE_UPDATED_SSE_TYPE,
  payload: AssetMergeUpdatedSsePayloadSchema,
  channelPrefix: 'asset-merge',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: () => 'WEB_APPLICATION',
    id: ({ applicationId }) => applicationId,
  },
});

export type AssetMergeUpdatedSsePayload = z.infer<
  typeof AssetMergeUpdatedSsePayloadSchema
>;
